import React from "react";
import { removeCookies } from "../../framework/redux/actions/cookiebar.actions";
import { PrimaryButton, ButtonText } from "BaseComponents/Button";
import { FlexContainer } from "BaseComponents/Flex";
import { useDispatch } from "react-redux";

const RevokeCookies = ({ settingsLabel }) => {
	const dispatch = useDispatch();
	return (
		<FlexContainer margin="0 0 1rem 0">
			<PrimaryButton
				onClick={(e) => {
					dispatch(removeCookies());
					e.preventDefault();
				}}
			>
				<ButtonText heading={`remove cookie`}>{settingsLabel}</ButtonText>
			</PrimaryButton>
		</FlexContainer>
	);
};

export default RevokeCookies;
